export const resolveDepositHoldId = (depositResp) => {
    if (depositResp?.status !== 'held') return null;
    return depositResp?.deposit_hold_id ?? null;
};

const DEFAULT_PENDING_MESSAGE = 'Your payment is on hold and your order will be placed automatically once it clears.';
const DEFAULT_SUCCESS_MESSAGE = 'Your physical card order has been submitted. You’ll receive updates as your order is processed.';

export const checkoutStatusMessage = (responseData) => {
    if (responseData?.status === 'pending') {
        return responseData?.message || DEFAULT_PENDING_MESSAGE;
    }
    return DEFAULT_SUCCESS_MESSAGE;
};

const DEFAULT_HELD_DEPOSIT_MESSAGE = 'Your payment was received and is on hold. The funds will be available once the hold clears.';

// A held deposit is successful (the card was charged) but not yet spendable, so it must not be
// reported as processed.
export const depositResponseModalState = (resp) => {
    if (!resp?.successful) {
        return { status: 'error', message: resp?.errorMessage ?? null };
    }
    if (resp?.status === 'held') {
        return { status: 'held', message: resp?.txt || DEFAULT_HELD_DEPOSIT_MESSAGE };
    }
    return { status: 'processed', message: null };
};
